import {
  INSTAPAY_ENROLL_FAILURE,
  INSTAPAY_ENROLL_REQUEST,
  INSTAPAY_ENROLL_SUCCESS,
  APPLY_COUPON_REQUEST,
  APPLY_COUPON_SUCCESS,
  APPLY_COUPON_FAILURE,
  CREATE_PAYMENT_CHECKOUT_REQUEST,
  CREATE_PAYMENT_CHECKOUT_SUCCESS,
  CREATE_PAYMENT_CHECKOUT_FAILURE,
  CREATE_BANK_TRANSFER_REQUEST,
  CREATE_BANK_TRANSFER_SUCCESS,
  CREATE_BANK_TRANSFER_FAILURE,
  UPLOAD_BANK_TRANSFER_RECEIPT_REQUEST,
  UPLOAD_BANK_TRANSFER_RECEIPT_SUCCESS,
  UPLOAD_BANK_TRANSFER_RECEIPT_FAILURE,
} from "../Actions/instaPayEnrollAction";

const initialState = {};

export const instaPayReducer = (state = initialState, action) => {
  const { teacherCourseId, parentCourseId, payload, type } = action;
  const courseId = teacherCourseId ?? parentCourseId;

  if (!courseId) {
    return state;
  }

  switch (type) {
    case INSTAPAY_ENROLL_REQUEST:
    case CREATE_PAYMENT_CHECKOUT_REQUEST:
    case CREATE_BANK_TRANSFER_REQUEST:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          loading: true,
          successMessage: null,
          checkout: null,
          bankTransfer: null,
          error: null,
        },
      };

    case INSTAPAY_ENROLL_SUCCESS:
    case CREATE_PAYMENT_CHECKOUT_SUCCESS:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          loading: false,
          successMessage:
            type === CREATE_PAYMENT_CHECKOUT_SUCCESS
              ? payload?.existingPending
                ? "Existing pending payment found."
                : "Online checkout opened."
              : "Booking request created successfully.",
          checkout: type === CREATE_PAYMENT_CHECKOUT_SUCCESS ? payload : null,
          error: null,
        },
      };

    case CREATE_BANK_TRANSFER_SUCCESS:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          loading: false,
          successMessage: "Bank transfer instructions created.",
          checkout: null,
          bankTransfer: payload,
          error: null,
        },
      };

    case INSTAPAY_ENROLL_FAILURE:
    case CREATE_PAYMENT_CHECKOUT_FAILURE:
    case CREATE_BANK_TRANSFER_FAILURE:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          loading: false,
          successMessage: null,
          checkout: null,
          bankTransfer: null,
          error: payload,
        },
      };

    case UPLOAD_BANK_TRANSFER_RECEIPT_REQUEST:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          receiptUploading: true,
          receiptError: null,
        },
      };

    case UPLOAD_BANK_TRANSFER_RECEIPT_SUCCESS:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          receiptUploading: false,
          receiptError: null,
          bankTransfer: payload,
        },
      };

    case UPLOAD_BANK_TRANSFER_RECEIPT_FAILURE:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          receiptUploading: false,
          receiptError: payload,
        },
      };

    case APPLY_COUPON_REQUEST:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          coupon: { loading: true, data: null, error: null },
        },
      };

    case APPLY_COUPON_SUCCESS:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          coupon: { loading: false, data: payload, error: null },
        },
      };

    case APPLY_COUPON_FAILURE:
      return {
        ...state,
        [courseId]: {
          ...(state[courseId] || {}),
          coupon: { loading: false, data: null, error: payload },
        },
      };

    case "CLEAR_STATUS_ERROR": {
      const existing = state[courseId];

      if (!existing) {
        return state;
      }

      return {
        ...state,
        [courseId]: {
          ...existing,
          error: null,
          successMessage: null,
          checkout: null,
          bankTransfer: null,
          receiptError: null,
          coupon: null,
        },
      };
    }

    default:
      return state;
  }
};
